import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LenderMatch from "@/pages/LenderMatch";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/lender-match")({
  head: () => seoHead("/lender-match"),
  component: () => (
    <AuthGate><LenderMatch /></AuthGate>
  ),
});
